// src/pages/Today.js
import React, { useState, useEffect } from "react";
import Typography from "../components/Typography";
import { spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";
import { useQueue } from "../context/QueueContext";

import Header from "../components/Header";
import ArticleCard from "../components/ArticleCard";
import "./TakashiPlayground.css";

import { getTopHeadlines, getEverything } from "../models/newsService";

import articles from "../models/todayNews.json";

function Today() {

  const { theme } = useTheme(); 
  const { addToQueue } = useQueue(); //  context
  const [activeTab, setActiveTab] = useState("Latest");
  const categories = ["Latest", "Business", "Technology", "Opinion", "U.S.", "World", "Books & Arts"];

  // Handle swipe right or button click to add to queue
  const handleAddToQueue = (article) => {
    addToQueue(article);
  };

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      overflow: "hidden",
      backgroundColor: theme.colors.background,
      color: theme.colors.text,
      padding: spacing.xxxs,
      // marginTop: "188px",
      boxSizing: "border-box",
    },
    tabContent: {
      padding: spacing.xxxs,
      height: "100%",
      overflowY: "scroll",
    },
  };


  return (
    <div style={styles.container}>
      <Header page = "Today"/>

      {/* <Tabs value={activeTab} onChange={(val) => setActiveTab(val)}>
        <TabsHeader>
          {categories.map((category) => (
            <Tab key={category} value={category}>
              {category}
            </Tab>
          ))}
        </TabsHeader>
        <TabsBody>
          {categories.map((category) => (
            <TabPanel key={category} value={category}>
              <div style={styles.tabContent}>
                {articles[category]?.length > 0 ? (
                  articles[category].map((article) => (
                    <ArticleCard
                      key={article.url} // Use URL as a unique key
                      article={article}
                      onSwipeRight={() => handleAddToQueue(article)}
                    />
                  ))
                ) : (
                  <Typography variant="summary" type="editorial">
                    No articles available.
                  </Typography>
                )}
              </div>
            </TabPanel>
          ))}
        </TabsBody>
      </Tabs> */}
      

      <div className="page-content" style={{ padding: spacing.xxxs, height: "100%", overflowY: "scroll" }}>
        {articles.map((article) => (
          <ArticleCard
            key={article.id}
            article={article}
            onSwipeRight={() => handleAddToQueue(article)}
          />
        ))}
      </div>
    </div>
  );
}

export default Today;